import { render } from "./ToDoPhasePaymentRequest.vue?vue&type=template&id=5fdb1d48&ts=true"
import script from "./ToDoPhasePaymentRequest.vue?vue&type=script&lang=ts"
export * from "./ToDoPhasePaymentRequest.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__